// Texts SalesForce integration
export const MANAGEMENT_SF_INTEGRATION_INFO_POINT_1 = "si.management.sf.section.info.point1";
export const MANAGEMENT_SF_INTEGRATION_INFO_POINT_2 = "si.management.sf.section.info.point2";
export const MANAGEMENT_SF_DISCONNECT_TOOLTIP = "si.management.sf.section.disconnect.tooltip";

export const MANAGEMENT_INTEGRATION_DESCRIPTION = "si.management.integration.section.description";

export const SL_LIST_MANAGEMENT_SF_INTEGRATION_STATUS_FAILED = "si.management.sf.section.integration-status.failed";
